<template>
  <div class="statistics_wrap">
    <p class="tips_p">小提示：部分统计数据为每日凌晨更新。</p>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userType: sessionStorage.getItem('userType')
    }
  },
  created() {
    let that = this
    
  },
  mounted() {
    
  },
}
</script>
<style lang="scss">
  .statistics_wrap{
    height: calc(100% - 30px);
    background: #f5f5f5;
    .tips_p{
      font-size: 10px;
      text-align: right;
      line-height: 30px;
      color: #5397F7
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/statistics/statisticsIndex.vue